import React, {useEffect, useState} from 'react';
import {Wheel} from "./Wheel";

export const Bogies = ({carNumber, ConditionService, EventsService, $uibModal}) => {
  const [bogies, setBogies] = useState([]);
  const [disconnectedBogies, setDisconnectedBogies] = useState([false, false]);

  const loadBogies = async () => {
    const params = {
      carIds: [carNumber]
    };
    const bogieData = await ConditionService.getLatestForCars(params);
    bogieData.forEach(car => {
      car.bogies.forEach(bogie => {
        bogie.categories.forEach(category => {
          category.assets.forEach(asset => {
            if (asset.ci_values != null) {
              asset.ci_values.map(ci => {
                ci.latestValue = _.last(ci.results).value;
              });
              const tempSensorBroken = asset.ci_values.find(ci => ci.valueType === "TEMP_MEDIAN_BROKEN");
              if (tempSensorBroken) {
                asset.tempSensorBroken = tempSensorBroken.status === 'ALARM';
              }
              const velocitySensorBroken = asset.ci_values.find(ci => ci.valueType === "ACCELERATION_RMS_BROKEN");
              if (velocitySensorBroken) {
                asset.velocitySensorBroken = velocitySensorBroken.status === 'ALARM';
              }
            }
          });
        });
      });
    });
    setBogies(bogieData[0].bogies); // Get the first car out of this.
  };

  const loadEthernetDisconnections = async () => {
    try {
      const params = {
        count: 10,
        skip: 0,
        sortType: 'ACTIVATED',
        cars: [carNumber],
        eventIds: [801, 804]
      };
      return await EventsService.getActiveFleetList(params);
    } catch (e) {
      console.error(`Event fetch error: ${e}`);
      return e;
    }
  };

  const loadDisconnections = async () => {
    const events = await loadEthernetDisconnections();
    const sg1Disconnected = events.filter(event => event.eventId === 801).length;
    const sg2Disconnected = events.filter(event => event.eventId === 804).length;
    setDisconnectedBogies([sg1Disconnected, sg2Disconnected]);
  };

  useEffect(() => {
    loadBogies();
    loadDisconnections();
  }, []);

  return (
    <div className="bogies">
      {bogies.map((bogie, i) => (
        <div key={"bogie-" + bogie.ordinal}
             className={"bogie" + (disconnectedBogies[i] ? " ethernet-disconnected" : "")}>
          <span className="title-bogie">{bogie.name + bogie.ordinal}</span>
          {[1, 2].map(axle => (
            <div className="axle"/>
          ))}
          {Boolean(disconnectedBogies[i]) && <span className="title-ethernet-disconnected"><i
            className="fa fa-ethernet"></i> Ethernet disconnected</span>}
          {bogie.categories[0].assets.map(wheel =>
            <Wheel key={"wheel-" + wheel.ordinal} carNumber={carNumber} bogie={bogie} wheel={wheel}
                   $uibModal={$uibModal}/>
          )}
        </div>
      ))}
    </div>
  );
};